/**
 * Classe responsável por realizar a paginação do grid.
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 24/07/2013
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.ScrollPagination = (function () {

  function ScrollPagination () {
    Monet.UI.Pagination.apply(this, arguments);

    this.setEntity = function (entity) {
      this.entity = entity;
    };

    this.setEntityToActionGrid = function(entityToActionGrid) {
      this.entityToActionGrid = entityToActionGrid;
    };

    this.getDataAndUpdateGrid = function (entity) {
      try {
        const filter = App.Objects[entity].getFilter ? App.Objects[entity].getFilter() : "";
        const appendCollection = true;
        const grid = App.Forms[entity].table;
        this.loading.setContainerToAppend(grid.getContainerNode());
        this.loading.init();
        this.loading.show();

        App.Objects[entity].updateGrid(filter, Monet.Grid.appendDataToGridAfterPagination, appendCollection);
      } catch (e) {
        const error = new Monet.Exception.ReturnError(this,
            "Error on get data to pagination grid.", e);
        error.console();
        App.Forms[entity].pagination.blocked = false;
      }
    };

    this.executePagination = function (entity) {
      const { NUMBER_INCREMENT } = Monet.Grid.Utils.paginationOptions;
      App.Forms[entity] = App.Forms[entity] || {};
      App.Forms[entity].pagination = App.Forms[entity].pagination || {
          first: 0,
          max: 51,
          blocked: false,
          canIncrement: true
      };

      const pagination = App.Forms[entity].pagination;

      if (!pagination.blocked) {
        if (pagination.canIncrement) {
            pagination.first += NUMBER_INCREMENT;
        }
        pagination.blocked = true;
        this.getDataAndUpdateGrid(entity);
      }
      return true;
    };
  }

  return ScrollPagination;
}());